const geyserDetailedRateCard = {
  key: "geyser",
  title: "Geyser Detailed Rate Card",
  note:
    "Indicative geyser pricing. Coil, thermostat, PCB, and internal electrical failures require inspection before exact pricing.",
  sections: [
    {
      title: "Inspection",
      items: [
        { name: "Geyser inspection", price: "₹249 visit" },
      ],
    },
    {
      title: "Repair Support",
      items: [
        { name: "Heating issue support", price: "₹399 onwards" },
        { name: "Leakage / outlet issue", price: "₹399 onwards" },
      ],
    },
    {
      title: "Installation",
      items: [
        { name: "Geyser installation", price: "₹699 onwards" },
      ],
    },
  ],
};

export default geyserDetailedRateCard;